<template>
    <v-app>
        <Navigator :showDrawer="drawer"></Navigator>
        <Snackbar />

        <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title style="width: 250px" class="ml-0 pl-4">
                <span class="hidden-sm-and-down">
                    <v-img src="../assets/geswatio mini.png"
                           aspect-ratio="1"
                           max-width="190px"
                           max-height="45"></v-img>
                </span>
            </v-toolbar-title>
            
            <div class="headline font-weight-thin">{{hayTitulo}}</div>
            <v-spacer />
            <span><v-img src="../assets/logo2.png"
       aspect-ratio="1"
       max-width="200"
       max-height="70"></v-img></span>
            <div class="username mr-3">{{ $auth.user().name }}</div>
            <!--<v-btn icon>
                <v-icon>mdi-bell</v-icon>
            </v-btn>-->

            <v-menu 
                    :open-on-hover="openOnHover"
                    :close-on-click="closeOnClick"
                    :close-on-content-click="closeOnContentClick"
                    :offset-y="offsetY">
                <template v-slot:activator="{ on }">
                    <v-btn icon
                           v-on="on">
                        <v-icon>mdi-account</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-title>{{ $auth.user().username }}</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="editUser">
                        <v-list-item-title>Editar Perfil</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logout">
                        <v-list-item-title>Salir</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-content>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <router-view></router-view>
                </v-row>
            </v-container>
        </v-content>
        <editProfile ref="editProfile">
        </editProfile>
    </v-app>

</template>

<script>
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Navigator from "@/components/navigator/Navigator.vue";
    import Snackbar from "@/components/snackbar.vue";
    import EditProfile from "@/views/pages/EditProfile.vue";

    @Component({
        computed: {
            hayTitulo: function (value) {
                if (this.$route.query.titulo != null) {
                    console.log("entre");
                    return this.$route.query.titulo;
                } else {
                    return this.$route.meta.title;
                }
            }
        },
        components: { Navigator, Snackbar, EditProfile },
        methods: {
            editUser: function () {
                this.showEditProfile();
            },
            logout: function () {
                this.$auth.logout({
                    makeRequest: false
                });
            }
        }

    })
    export default class DefaultContainer extends Vue {
        drawer = false;
        openOnHover = true;
        closeOnClick = true;
        closeOnContentClick = true;
        offsetY = true;
    }
</script>